import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from '../../common/Modal/Modal';
import PersonaCreatorViewAttitudeData from './PersonaCreatorViewAttitudeData';
import clearIcon from '../../../images/clear-field-icon.png';
import saveIcon from '../../../images/save-to-cloud-icon.png';
import { ATTITUDINAL_TEMPLATE_NAME_EXCEED_WARNING, CREATOR_CLUSTER_COUNT_WARNING_MSG } from '../../../messages/messages';
import { CREATOR_SAVE_TEMPLATE_NAME, APPLY_SEGMENT_CLUSTERS_CREATOR } from '../../../constants';


const clusterWarningModalStyle = {
  width: '40%',
  height: '100%',
  left: '30%',
  top: '20%',
  fontSize: '15px',
  zIndex: '10000',
};
const modalSettingStyle = {
  width: '60%',
  height: '40px',
  left: '20%',
  top: '2%',
};


class PersonaCreatorClusterSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      segmentCount: this.props.segmentCount,
      attitudesList: this.props.attitudesList,
      clusterStatExpressions: this.props.clusterStatExpressions,
      selctedExpressionObject: this.props.selectedExpressionObject,
      saveTemplateName: '',
      selectedAttitudinal: this.props.selectedAttitudinalTemplate,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.showClusterSettingsModal.value === true) {
      this.genericModal.show();
      this.props.showClusterSettingsModal.callback();
    }
  }

  onSettingIconClick = () => {
    this.showModalPopup();
    this.setState({ saveTemplateName: '' });
  };

  onChangeSegmentsCount = value => {
    this.setState({
      segmentCount: parseInt(value, 10),
    });
  };

  onChangeSelectedAttitudesList = (value, expressionObject) => {
    this.setState({
      clusterStatExpressions: value,
      selctedExpressionObject: expressionObject,
    });
  };

  onChangeTemplateName = e => {
    if (e.target.value.length <= 60) {
      this.setState({
        saveTemplateName: e.target.value,
      });
    }
  };

  onClearTemplateName = () => {
    this.setState({
      saveTemplateName: '',
    });
  };

  onSelectAttitudinal = attitudinal => {
    this.setState({
      selectedAttitudinal: attitudinal,
    });
  };

  onSaveAttitudinal = () => {
    const attitudinalData = [];
    const keywords = [];
    this.state.selctedExpressionObject.map(obj => keywords.push(obj.keyword));
    const attitudinalObject = {
      id: null,
      name: this.state.saveTemplateName,
      keywords,
    };
    attitudinalData.push(attitudinalObject);
    this.props.trackerFn({ action: CREATOR_SAVE_TEMPLATE_NAME });
    this.props.saveAttitudinalTemplate(
      attitudinalData,
      this.state.selctedExpressionObject,
    );
    this.onClearTemplateName();
  };

  applySegmentClusters = () => {
    const countVal = (_.split(this.state.selctedExpressionObject[0].value, ',').length / 2);
    if (this.state.selctedExpressionObject.length === 1 && countVal < this.state.segmentCount) {
      this.clusterWarningModal.show();
    } else {
      this.genericModal.hide();
      this.props.trackerFn({
        action: APPLY_SEGMENT_CLUSTERS_CREATOR,
        attributes: { expression: this.state.selctedExpressionObject },
      });
      // let abc;
      this.props.createClusterSegments(
        this.state.segmentCount,
        this.state.clusterStatExpressions,
        this.state.selctedExpressionObject,
        this.state.selectedAttitudinal,
      );
    }
  };

  showModalPopup = () => {
    this.genericModal.show();
    this.setState({
      selectedAttitudinal: this.props.selectedAttitudinalTemplate,
    });
  };

  render() {
    const {
      fetchClusterStatementsData,
      attitudesList,
      segmentCount,
      clusterStatExpressions,
      selectedExpressionObject,
      attitudinalTemplate,
      defaultExpression,
      defaultExpressionObject,
      selectedAttitudinalTemplate,
    } = this.props;
    return (
      <div className="display-inline-block">
        <span
          className="persona-cluster-setting-icon"
          style={{ display: 'inline-block' }}
          onClick={() => this.onSettingIconClick()}
        >
          <i className="glyphicon glyphicon-cog" />
          <p className="setting-icon-text">ATTITUDE</p>
        </span>
        <div className="row persona-cluster-settings-div-layout">
          <Modal
            title=""
            ref={node => (this.clusterWarningModal = node)}
            dialogStyles={clusterWarningModalStyle}
          >
            <div className="clusterWarningModal">
            {CREATOR_CLUSTER_COUNT_WARNING_MSG}
            </div>
          </Modal>
        </div>
        <div className="persona-cluster-settings-div-layout">
          <Modal
            title="Clustering Settings"
            ref={node => (this.genericModal = node)}
            dialogStyles={modalSettingStyle}
          >
            <div className="text-center">
              <div className="">
                <PersonaCreatorViewAttitudeData
                  fetchClusterStatementsData={fetchClusterStatementsData}
                  attitudesList={attitudesList}
                  selectedAttitudesList={clusterStatExpressions}
                  segmentCount={segmentCount}
                  onChangeSegmentsCount={this.onChangeSegmentsCount}
                  onChangeSelectedAttitudesList={
                    this.onChangeSelectedAttitudesList
                  }
                  selectedExpressionObjectData={selectedExpressionObject}
                  attitudinalTemplate={attitudinalTemplate}
                  onSelectAttitudinal={this.onSelectAttitudinal}
                  defaultExpression={defaultExpression}
                  defaultExpressionObject={defaultExpressionObject}
                  selectedAttitudinalTemplate={selectedAttitudinalTemplate}
                />
              </div>
              <div className="modal-footer">
                <div className="large-12 medium-12 small-12 columns">
                  <div className="large-10 medium-10 small-10 columns">
                    {this.state.selctedExpressionObject.length > 0 &&
                      _.isEmpty(this.state.selectedAttitudinal) && (<div className="embed-submit-field">
                        <input
                          type="text"
                          placeholder="TEMPLATE NAME"
                          value={this.state.saveTemplateName}
                          onChange={this.onChangeTemplateName}
                        />
                        {this.state.saveTemplateName.length > 0 && (
                          <span>
                            <button
                              type="button"
                              style={{
                                marginRight: '8%',
                                marginTop: '0.6%',
                                padding: '0%',
                              }}
                              title="Clear"
                              onClick={() => {
                                this.onClearTemplateName();
                              }}
                            >
                              <img
                                alt="clear_icon"
                                className="embed_clear_icons_img"
                                src={clearIcon}
                              />
                            </button>

                            <button
                              type="button"
                              style={{ marginRight: '-2%' }}
                              title="Save Template"
                              onClick={() => {
                                this.onSaveAttitudinal();
                              }}
                            >
                              <img
                                alt="save_icon"
                                className="embed_save_icons_img"
                                src={saveIcon}
                              />
                            </button>
                          </span>
                        )}
                      </div>
                      )}
                    {this.state.selctedExpressionObject.length > 0 &&
                      _.isEmpty(this.state.selectedAttitudinal) && (<span>
                        {`*${ATTITUDINAL_TEMPLATE_NAME_EXCEED_WARNING}`}
                      </span>
                      )}
                  </div>
                  <div className=" large-2 medium-2 small-2 columns button-group  float-right pull-down">
                    <button
                      type="button"
                      className="btn btn-primary persona-cluster-settings-button margin-top-10"
                      onClick={this.applySegmentClusters}
                    >
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

PersonaCreatorClusterSettings.propTypes = {
  createClusterSegments: PropTypes.func,
  saveAttitudinalTemplate: PropTypes.func,
  trackerFn: PropTypes.func,
};

export default PersonaCreatorClusterSettings;
